import {
  ChartPieIcon,
  UserIcon,
  CogIcon,
  LifebuoyIcon,
  PlusIcon,
  UsersIcon,
  CalendarIcon,
  FolderIcon,
  ArchiveBoxIcon,
  ClipboardDocumentIcon,
  BookOpenIcon,
  BellIcon,
  EnvelopeIcon,
  LockClosedIcon,
  ShieldCheckIcon,
  WrenchScrewdriverIcon,
  GlobeAltIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
export const MenuItems = [
  { name: 'Dashboard', path: '/dashboard', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
  { name: 'Register Candidate', path: '/student-register-list',roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
    {
    name: 'Request',
    roles:["admin"],
    icon: <UserIcon className="h-5 w-5" />,
    children: [
      { name: 'College Request', path: '/college-register-list', roles:["admin"], icon: <UsersIcon className="h-5 w-5" /> },
      { name: 'Mentor Request', path: '/Mentor-register-list', roles:["admin"], icon: <UsersIcon className="h-5 w-5" /> },
    ],
  },
  {
   name: 'Users',
   roles:["admin"],
    icon: <UserIcon className="h-5 w-5" />,
    children: [
      { name: 'Add User', path: '/add', icon: <PlusIcon className="h-5 w-5" /> },
      { name: 'Manage Users', path: '/users', icon: <UsersIcon className="h-5 w-5" /> },
    ],
  },
  {
    name: 'Traning',
    roles:["admin"],
    icon: <UserIcon className="h-5 w-5" />,
    children: [
      { name: 'Module', path: '/module-list', icon: <ChartPieIcon className="h-5 w-5" /> },
    ],
  },

  { name: 'Roadmap', path: '/roadmap/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
  
    {
    name: 'Robotics Section',
   roles:["admin"],
    icon: <UserIcon className="h-5 w-5" />,
    children: [
        { name: 'Robotics kit', path: '/roboticskit/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Robotic Syallbus', path: '/robotic-syallbus/list', roles:["admin"], icon: <PlusIcon className="h-5 w-5" /> },
        { name: 'Robotics Image', path: '/roboticsimage/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
    ], 
    },
{ name: 'Attendance', path:'/show/attendance', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
  { name: 'User-Mangement', path: '/users-mangement', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
  { name: 'College|School', path: '/college-list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
  { name: 'Add Student', path: '/admin/student-list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      // { name: 'Modules', path: '/modules/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },

      { name: 'Mentor', path: '/mentor/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Program Service', path: '/program-service/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },

        {
    name: 'Website',
    roles:["admin"],
    icon: <UserIcon className="h-5 w-5" />,
    children: [
      { name: 'Blogs', path:'/blog/list', roles:["admin"], icon: <PlusIcon className="h-5 w-5" /> },
      { name: 'Case Study Gallery', path: '/gallery/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },

      { name: 'Case Study', path:'/case-study/list', roles:["admin"], icon: <PlusIcon className="h-5 w-5" /> },

      { name: 'Home-Banner', path: '/homebanner-list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Service', path: '/service/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Program', path: '/program/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Quiz', path: '/quiz/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
      { name: 'Project', path: '/projects/list', roles:["admin"], icon: <PlusIcon className="h-5 w-5" /> },
      { name: 'Testimonial', path: '/testimonial/list', roles:["admin"], icon: <UsersIcon className="h-5 w-5" /> }, // Consider removing if name is empty
      { name: 'Modules', path: '/modules/list', roles:["admin"], icon: <PlusIcon className="h-5 w-5" /> },
    ],
  },


// {
//     name: 'Program Service',
//    roles:["admin"],
//     icon: <UserIcon className="h-5 w-5" />,
//     children: [
//         { name: 'Program Service Add', path: '/program-service/add', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
//         { name: 'Program Service List', path: '/program-service/list', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
//         { name: 'Program Service Edit', path: '/program-service/edit/:id', roles:["admin"], icon: <ChartPieIcon className="h-5 w-5" /> },
//     ],
//   },
   // Mentor
  { name: 'Home', path: '/mentor/home', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" /> },
  // { name: 'Chatbot', path: '/mentor/chatbot', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" /> },
   { name: 'Students', path: '/mentor/student-list', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
   { name: 'Groups', path: '/mentor/groups-list', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
   { name: 'Create Tasks', path: '/mentor/task-list', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
   { name: 'Assign Task', path: '/mentor-assigntask', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
  { name: 'Assessments', path: '/mentor-assessments/list', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" /> },
  //  { name: 'Profile', path: '/profile', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
  { name: 'Sessions', path: '/mentor/session/list', roles:["mentor"], icon: <ChartPieIcon className="h-5 w-5" role='mentor' /> },
   //Student
   { name: 'Attendance', path: '/attendance/list',roles:["student"], icon: <ChartPieIcon className="h-5 w-5" /> },
   { name: 'Home', path: '/road-map', roles:["student"], icon: <ChartPieIcon className="h-5 w-5"/> },
  //  { name: 'Chatbot', path: '/student-chatbot', roles:["student"], icon: <ChartPieIcon className="h-5 w-5"/> },
  { name: 'MY Profile', path: '/student/profile',roles:["student"], icon: <ChartPieIcon className="h-5 w-5"/> },

   { name: 'Mentor', path: '/student-mentors', roles:["student"],icon: <ChartPieIcon className="h-5 w-5"/> },
   { name: 'Resources', path: '/student-resoures', roles:["student"],icon: <ChartPieIcon className="h-5 w-5"/> },
   { name: 'Daily Tasks', path: '/daily/student-task', roles:["student"],icon: <ChartPieIcon className="h-5 w-5"/> },
   { name: 'Progress', path: '/student-progress',roles:["student"], icon: <ChartPieIcon className="h-5 w-5" /> },
   { name: 'Sessions', path: '/student-sessions', roles:["student"],icon: <ChartPieIcon className="h-5 w-5"/> },

  { name: 'Assessments-test', path: '/assessments-test',roles:["student"], icon: <ChartPieIcon className="h-5 w-5" /> },

];